import { Observable } from "rxjs";
import { Clinic, DataSourceFilter, DataSourceResponse, Department } from "../../models";

export abstract class ManualApi {

  abstract getClinics(filter: DataSourceFilter): Observable<DataSourceResponse<Clinic>>;
  abstract getDepartments(filter: DataSourceFilter): Observable<DataSourceResponse<Department>>;
}
